import React from "react";
import "./css/d1.css"; // styles below

export default function MenuTemplate1({ menu, categories }) {
  if (!menu || !categories) return <p>Loading…</p>;

  const colors = menu.colors || {
    primary: "#2e7d32",
    background: "#fafafa",
    text: "#222",
    card: "#ffffff",
  };

  return (
    <div
      className="menuT1-container"
      style={{ backgroundColor: colors.background, color: colors.text }}
    >
      {/* HEADER IMAGE */}
      {menu.imageUrl && (
        <img
          src={menu.imageUrl}
          alt="Menu Header"
          className="menuT1-headerImage"
        />
      )}

      {/* TITLE */}
      <div className="menuT1-header">
        <h1>{menu.name}</h1>
        {menu.tagline && <p className="menuT1-tagline">{menu.tagline}</p>}
      </div>

      {/* CATEGORY + ITEMS */}
      <div className="menuT1-content">
        {categories.map((cat) => (
          <section
            key={cat.id}
            className="menuT1-category"
            style={{ background: colors.card }}
          >
            <h2
              className="menuT1-categoryTitle"
              style={{ borderColor: colors.primary }}
            >
              {cat.name}
            </h2>

            <div className="menuT1-items">
              {cat.items.map((item) => (
                <div key={item.id} className="menuT1-item">
                  {/* Optional Image */}
                  {item.imageUrl && (
                    <img
                      src={item.imageUrl}
                      className="menuT1-itemImage"
                      alt={item.name}
                    />
                  )}

                  <div className="menuT1-itemInfo">
                    <div>
                      <h3>{item.name}</h3>
                      {item.description && (
                        <p className="menuT1-itemDesc">{item.description}</p>
                      )}
                    </div>

                    <div
                      className="menuT1-itemPrice"
                      style={{ color: colors.primary }}
                    >
                      ${parseFloat(item.price).toFixed(2)}
                    </div>
                  </div>
                </div>
              ))}

              {cat.items.length === 0 && (
                <p className="menuT1-empty">No items yet</p>
              )}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
